/**
 * Quantity Breaks - Bundle JS
 * File: assets/quantity-breaks.js
 *
 * Handles:
 * 1. +/- buttons → step through Piece variant radios (bundle cards)
 * 2. Quantity input sync after AJAX re-render
 * 3. Card selected state after AJAX re-render
 * 4. Page load initial sync
 */
(function () {
  "use strict";

  // =============================================
  // HELPER: Find the quantity-breaks fieldset and its radios
  // =============================================
  function getPieceData() {
    var fieldset = document.querySelector(".quantity-breaks-fieldset");
    if (!fieldset) return null;

    var radios = Array.from(
      fieldset.querySelectorAll('input[type="radio"].quantity-break-radio')
    );
    if (radios.length === 0) return null;

    return { fieldset: fieldset, radios: radios };
  }

  // =============================================
  // HELPER: Extract piece number from label text (e.g. "2 Piece" → 2)
  // =============================================
  function getPieceNumber(radio) {
    var label = document.querySelector('label[for="' + radio.id + '"]');
    if (label) {
      var match = label.textContent.match(/(\d+)/);
      if (match) return parseInt(match[1]);
    }
    return 1;
  }

  // =============================================
  // HELPER: Get currently checked radio's index
  // =============================================
  function getCurrentIndex(radios) {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return i;
    }
    return 0;
  }

  // =============================================
  // HELPER: Update quantity input value (skip sticky ATC)
  // =============================================
  function syncQuantityInput(qty) {
    var inputs = document.querySelectorAll(
      'quantity-input input[name="quantity"]'
    );
    inputs.forEach(function (input) {
      if (!input.closest("sticky-add-cart")) {
        input.value = qty;
      }
    });
  }

  // =============================================
  // HELPER: Update card visual selected states
  // =============================================
  function updateCardStates(pieceData) {
    if (!pieceData) return;
    pieceData.radios.forEach(function (radio) {
      var card = radio.closest(".quantity-break-card");
      if (card) {
        if (radio.checked) {
          card.classList.add("quantity-break-card--selected");
        } else {
          card.classList.remove("quantity-break-card--selected");
        }
      }
    });
  }

  // =============================================
  // HELPER: Sync quantity + card states after AJAX re-render
  // Multiple delays to counter Shopify AJAX overwrites
  // =============================================
  function syncAfterAjax() {
    [800, 1500, 2500].forEach(function (delay) {
      setTimeout(function () {
        var freshData = getPieceData();
        if (freshData) {
          // Quantity hamesha 1 — variant khud bundle hai (e.g. "2 Piece" = 2 pieces)
          syncQuantityInput(1);
          updateCardStates(freshData);
        } else {
          syncQuantityInput(1);
        }
      }, delay);
    });
  }

  // =============================================
  // MAIN: Intercept +/- button clicks (capture phase)
  // Steps through bundle cards instead of default +1/-1
  // =============================================
  document.body.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(
        'button[name="plus"], button[name="minus"]'
      );
      if (!btn) return;

      // Skip sticky ATC buttons
      if (btn.closest("sticky-add-cart")) return;

      var pieceData = getPieceData();
      // If no bundle cards exist, let default behavior work
      if (!pieceData) return;

      // Stop default +1/-1 behavior
      e.preventDefault();
      e.stopPropagation();

      var direction = btn.getAttribute("name"); // 'plus' or 'minus'
      var currentIndex = getCurrentIndex(pieceData.radios);
      var newIndex = currentIndex;

      if (direction === "plus" && currentIndex < pieceData.radios.length - 1) {
        newIndex = currentIndex + 1;
      } else if (direction === "minus" && currentIndex > 0) {
        newIndex = currentIndex - 1;
      }

      if (newIndex !== currentIndex) {
        // Select the new piece radio
        pieceData.radios[newIndex].checked = true;

        // Fire change event → theme's AJAX will handle variant update
        pieceData.radios[newIndex].dispatchEvent(
          new Event("change", { bubbles: true })
        );

        // Quantity hamesha 1 — variant khud bundle hai
        syncQuantityInput(1);
        updateCardStates(pieceData);

        // Sync again after AJAX re-render
        syncAfterAjax();
      }
    },
    true
  ); // true = capture phase (fires before theme's handler)

  // =============================================
  // SYNC: When a bundle card radio is clicked directly, sync quantity
  // =============================================
  document.body.addEventListener("change", function (e) {
    if (
      !e.target.matches ||
      !e.target.matches('input[type="radio"].quantity-break-radio')
    )
      return;

    var pieceData = getPieceData();
    if (!pieceData) return;

    // Quantity hamesha 1 — variant khud bundle hai
    syncQuantityInput(1);
    updateCardStates(pieceData);
    syncAfterAjax();
  });

  // =============================================
  // INITIAL: Sync quantity + card states on page load
  // =============================================
  setTimeout(function () {
    var pieceData = getPieceData();
    if (pieceData) {
      // Quantity hamesha 1 — variant khud bundle hai
      syncQuantityInput(1);
      updateCardStates(pieceData);
    }
  }, 500);
})();
